import { AudiencePage } from "@/components/audience-page";
import { FOR_COUPLES_FAQ_KEYS } from "@/pages/for-couples-content";

export function ForCouplesComponent() {
  return <AudiencePage audience="couples" faqs={FOR_COUPLES_FAQ_KEYS} />;
}
